import "core-js/modules/es6.number.constructor";
export default {
  props: {
    type: {
      type: String,
      required: true
    },
    level: {
      type: Number,
      default: 0
    }
  },
  computed: {
    text: function text() {
      if (this.type === 'level') {
        return this.getLevelDisplay(this.level);
      } else {
        return this.type.toUpperCase();
      }
    }
  }
};